import React, { useState } from 'react'
import { Button, Modal } from 'antd';

import { BASIC_COIN_DROP } from '../../config/media';
import CollateralMemberColumn from './CollateralMemberColumn';
import MembershipDetailsWrapper from './style';

export const membershipData = {
    tier: {
        title: 'Tier 0',
        description_1: 'Free software usage',
        description_2: ' 0% profit margins',
        icon: BASIC_COIN_DROP,
        section: [
            {
                title: 'Exchange software',
                smallDescription: 'Unlimited usage of HollaEx Kit'
            },
            {
                title: 'Network trading pairs',
                smallDescription: 'Add any default trading pairs'
            }
        ],
        footer: {
            title: 'FREE!',
            smallDescription: 'No staked required'
        }
    },
    lite: {
        title: 'Lite member',
        description_1: 'Partically collateralized member',
        description_2: ' Medium profit margins',
        icon: BASIC_COIN_DROP,
        section: [
            {
                title: 'Exchange software',
                smallDescription: 'Unlimited usage of HollaEx Kit'
            },
            {
                title: 'Network trading pairs',
                smallDescription: 'Add any default trading pairs'
            },
            {
                title: 'Increased profit margins*',
                smallDescription: 'Earn up to 50%* from any trading fees on your project'
            },
            {
                title: 'Passive income',
                smallDescription: 'Earn network trade fees and newly minted tokens from network'
            }
        ],
        footer: {
            title: '50,000 XHT',
            smallDescription: 'staked collateral required'
        }
    },
    holla: {
        title: 'Holla member',
        description_1: 'Fully collateralized member',
        description_2: ' Highest profit margins',
        icon: BASIC_COIN_DROP,
        section: [
            {
                title: 'Exchange software',
                smallDescription: 'Unlimited usage of HollaEx Kit'
            },
            {
                title: 'Network trading pairs',
                smallDescription: 'Add any default trading pairs'
            },
            {
                title: 'Increased profit margins*',
                smallDescription: 'Earn up to 99.9%* from any trading fees on your project'
            },
            {
                title: 'Passive income',
                smallDescription: 'Earn network trade fees and newly minted tokens from network'
            },
            {
                title: 'Trading rebates',
                smallDescription: 'Offer -2.5 bps on all market maker trades'
            }
        ],
        footer: {
            title: '500,000 XHT',
            smallDescription: 'staked collateral required'
        }
    }
}

const CollateralMembers = ({ isVisible, handleCancel }) => {
    const [modalType, setType] = useState("collateral")

    const closeModal = () => {
        handleCancel();
    };

    const renderContent = () => {
        switch (modalType) {
            case "soon":
                return (
                    <MembershipDetailsWrapper>
                        <div className="text-center">
                            <h2>Coming soon</h2>
                        </div>
                    </MembershipDetailsWrapper>
                )
            case "collateral":
            default:
                return (
                    <MembershipDetailsWrapper>
                        <div className="title">Collateral membership levels</div>
                        <span className="sub-title">
                            More you stake the more network earnings can be earnt with increase profit margin for exchange operators.
                        </span>
                        <div className="box-container">
                            <div className="content-wrapper">
                                <CollateralMemberColumn type='tier' />
                                <CollateralMemberColumn type='lite' />
                                <CollateralMemberColumn type='holla' />
                            </div>
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={closeModal}>Back</Button>
                            <div className="separator"></div>
                            <Button onClick={() => setType("soon")} type="primary">Calculate profit margins</Button>
                        </div>
                    </MembershipDetailsWrapper>
                )
        }
    }
    return (
        <Modal
            width={750}
            visible={isVisible}
            onCancel={closeModal}
            footer={null}
        >
            {renderContent()}
        </Modal>
    )
}

export default CollateralMembers;
